import { render, staticRenderFns } from "./ProductPageTemplate.vue?vue&type=template&id=703632ac&scoped=true&"
import script from "./ProductPageTemplate.vue?vue&type=script&lang=js&"
export * from "./ProductPageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703632ac",
  null
  
)

export default component.exports